module.exports = __webpack_public_path__ + "static/media/gb.bb5cdc41.svg";